import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import React from 'react';

const ReviewQuestionFieldTextType = ({ value, header }) => {
  return (
    <React.Fragment>
      <Row gutter={16}>
        <Col span={10}>
          <h4> {value} </h4>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ReviewQuestionFieldTextType;
